import React from 'react'
import { Home as HomeIcon, Gamepad2, ShoppingBag, Sparkles, Coins } from 'lucide-react'
import { playSoundSafe } from '../utils/audio'

export type BottomNavKey = 'home' | 'games' | 'market' | 'quest' | 'staking'

interface BottomNavProps {
  activeNav: BottomNavKey
  onNavClick: (nav: BottomNavKey) => void
}

const NAV_ITEMS: Array<{ id: BottomNavKey; label: string; icon: React.ComponentType<{ className?: string }> }> = [
  { id: 'home', label: 'Home', icon: HomeIcon },
  { id: 'games', label: 'Games', icon: Gamepad2 },
  { id: 'market', label: 'Market', icon: ShoppingBag },
  { id: 'quest', label: 'Quest', icon: Sparkles },
  { id: 'staking', label: 'Staking', icon: Coins },
]

/**
 * AGC: Shared bottom navigation bar for Base App screens.
 * AGC: Provides quick access to primary sections with consistent styling.
 */
export const BottomNav: React.FC<BottomNavProps> = ({ activeNav, onNavClick }) => {
  return (
    <nav data-tour="bottom-nav" className="fixed bottom-0 left-0 w-full h-[64px] bg-slate-900/90 backdrop-blur-md border-t border-slate-800/60 flex justify-around items-center text-xs font-medium z-40 shadow-[0_-4px_12px_rgba(0,0,0,0.5)]">
      {NAV_ITEMS.map((item) => {
        const Icon = item.icon
        const isActive = activeNav === item.id
        return (
          <button
            key={item.id}
            data-tour={`nav-${item.id}`}
            onClick={() => {
              playSoundSafe('/sounds/click.mp3', 0.3)
              onNavClick(item.id)
            }}
            className={`flex flex-col items-center gap-1 transition-colors ${
              isActive ? 'text-blue-400' : 'text-slate-400 hover:text-slate-200'
            }`}
          >
            <Icon className="w-5 h-5" />
            {item.label}
          </button>
        )
      })}
    </nav>
  )
}

